import React, { useEffect } from "react";
import Helmet from "react-helmet";
import cookies from "cookies-js";
import window from "global/window";
import { LocalStorageWrapper } from "@src/utils/localStorage";

const OneTrustScript = ({ setPerformanceCookieConsent, setTargetingCookieConsent }) => {
  useEffect(() => {
    window.addEventListener("OneTrustGroupsUpdated", () => {
      const oneTrustCookie = cookies.get("OptanonConsent");

      if (oneTrustCookie && oneTrustCookie.includes("C0002:1") && setPerformanceCookieConsent) {
        setPerformanceCookieConsent(true);
      }

      if (oneTrustCookie && oneTrustCookie.includes("C0004:1") && setTargetingCookieConsent) {
        setTargetingCookieConsent(true);
      }

      if (
        oneTrustCookie &&
        (oneTrustCookie.includes("C0002:0") ||
          oneTrustCookie.includes("C0003:0") ||
          oneTrustCookie.includes("C0004:0") ||
          oneTrustCookie.includes("C0005:0"))
      ) {
        LocalStorageWrapper.clear();
        LocalStorageWrapper.disable("localstorage blocked, see cookie preferences");
      }
    });
  }, [setPerformanceCookieConsent, setTargetingCookieConsent]);

  return (
    <>
      {
        <Helmet>
          <script
            type="text/javascript"
            crossOrigin="anonymous"
            src="https://cdn.cookielaw.org/consent/488d15e8-5436-4ecc-b202-0d14fac3afe8/OtAutoBlock.js"
          ></script>
          <script
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            data-document-language="true"
            type="text/javascript"
            crossOrigin="anonymous"
            charset="UTF-8"
            data-domain-script="488d15e8-5436-4ecc-b202-0d14fac3afe8"
          ></script>
          <script type="text/javascript">{`function OptanonWrapper() {
      const event = new Event('OneTrustGroupsUpdated');
      window.dispatchEvent(event)

      }`}</script>
        </Helmet>
      }
    </>
  );
};

export default OneTrustScript;
